import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOptionSchema } from "../generic";
import { ReactSelectOption } from "../../models/generic/ReactSelectOption";
import { NavListItem } from "../../models/adminNav";

export interface NavRedirectEditData {
    id: number;
    isExternal: boolean;
    active: boolean;
    onMenu: boolean;
    parentId: ReactSelectOption | NavListItem | null;
    redirectToId: ReactSelectOption | NavListItem | null;
    title: string;
    url?: string;
}

export class NavRedirectEdit implements FormValidationModel<NavRedirectEditData> {
    public data: NavRedirectEditData;
    public rules: yup.Schema<NavRedirectEditData>;

    public constructor() {
        this.data = {
            id: 0,
            isExternal: false,
            active: true,
            onMenu: true,
            parentId: null,
            redirectToId: null,
            title: "",
            url: "",
        };
        this.rules = yup.object<NavRedirectEditData>().shape({
            id: yup.number().required().label("ID").min(0, "Invalid ID"),
            isExternal: yup.boolean().required().label("External or jump-to link"),
            active: yup.bool(),
            onMenu: yup.bool().label("Show on menu"),
            parentId: ReactSelectOptionSchema.label("Parent").required(),
            redirectToId: ReactSelectOptionSchema.label("Redirects to").when("isExternal", {
                is: false,
                then: ReactSelectOptionSchema.required(),
                otherwise: ReactSelectOptionSchema.nullable(true),
            }),
            title: yup.string().required(),
            url: yup.string().label("Redirects to URL").when("isExternal", {
                is: true,
                then: yup.string().required(),
                otherwise: yup.string().nullable(true),
            }),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminNav/NavRedirectEdit.ts